import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
import { VersionType } from "@/types/genericVersionTypes";
import { VersionsResponse } from "@/backend/express/controllers/functionalInterfaceVersionController";

export class FunctionalInterfaceVersionController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/functional-interface-versions/${id}`);
  }

  public async publish(versionId: string, functionalInterfaceId: string, versionType: VersionType): Promise<FusaReply> {
    return this.client.update(`/api/functional-interface-versions/publish`, { versionId, functionalInterfaceId, versionType });
  }

  public async readAllForProcedure(procedureId: string): Promise<VersionsResponse> {
    return this.client.read(`/api/functional-interface-versions/all-for-procedure/${procedureId}`);
  }
}
